<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @openUploadFile="openUploadFile"
      @checkboxChange="checkboxChange"
      @sendEmail="sendEmail"
      @confirm="confirm"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      >
        <template slot-scope="{ form }">
          <el-badge
            v-if="allow('E')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              v-if="allow('E')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="exportFile(form)"
            >
              {{ $l('INDEX.btn_export') || '导出' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckList" />
            </b-button>
          </el-badge>

          <el-badge
            v-if="allow('S')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              v-if="allow('S')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              :disabled="!checkedRowCount"
              @click="batchSendEmail()"
            >
              {{ $l('btn_tips_email') || '邮件发送' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckList" />
            </b-button>
          </el-badge>
          <el-badge
            v-if="allow('F')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              v-if="allow('F')"
              size="sm"
              class="ml-2"
              :disabled="!checkedRowCount"
              variant="outline-success"
              @click="batchConfirm()"
            >
              {{ $l('btn_tips_confirm') || '订单确认' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckList" />
            </b-button>
          </el-badge>
        </template>
      </page-header>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <Detail
      :visible.sync="evgOnlineOrderOptions.visible"
      :orderCode="evgOnlineOrderOptions.orderCode"
    ></Detail>
    <UploadFile
      :visible.sync="evgUploadFileOptions.visible"
      :orderCode="evgUploadFileOptions.orderCode"
    ></UploadFile>
    <chooseTemplate
      @export-success="clearCheckList"
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'ecom-order' }"
      :exportOptions="{
        params: {
          searchForm: chooseTemplateOptions.searchForm,
        },
      }"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import Detail from '../../detail'
import UploadFile from '../upload-file'
import chooseTemplate from '@/views/ecom/components/choose-template'

export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, Detail, chooseTemplate, UploadFile },
  data() {
    return {
      usePage: true,
      evgOnlineOrderOptions: {
        visible: false,
        orderCode: '',
      },
      evgUploadFileOptions: {
        visible: false,
        orderCode: '',
      },
      chooseTemplateOptions: {
        visible: false,
        searchForm: {},
      },
      checkList: [],
      checkedRow: [],
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkList?.length || 0
    },
  },
  methods: {
    clearCheckList() {
      this.$refs.main.removeCheckboxRow()
      this.checkList = []
    },
    getData(form) {
      this.loading = true
      this.$api
        .ecomOrderListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    exportFile(form) {
      this.chooseTemplateOptions.visible = true
      this.chooseTemplateOptions.searchForm = form || {}
      this.chooseTemplateOptions.searchForm.checkList = this.checkList
    },
    openUploadFile({orderCode}) {
      this.evgUploadFileOptions.visible = true
      this.evgUploadFileOptions.orderCode = orderCode
    },
    openEditPage({ orderCode }) {
      this.evgOnlineOrderOptions.visible = true
      this.evgOnlineOrderOptions.orderCode = orderCode
    },
    checkboxChange(data) {
      const tmp = data?.map((e) => e.orderCode || '') || []
      this.checkList = tmp.filter((e) => Boolean(e))
      this.checkedRow = data
    },
    batchSendEmail() {
      if (!this.checkList || this.checkList.length == 0) {
        this.$message({
          showClose: true,
          message:
            this.$l('please_select_the_data') || '请选择需要发送邮件的数据',
          type: 'warning',
        })
        return
      }
      // 获取已关联请款单的结算单编号
      const errorKeys = this.checkedRow
        .filter((item) => item.orderStatus != '11')
        .map((item) => item.orderNo)

      if (errorKeys && errorKeys.length) {
        this.$message({
          message: `订单[${errorKeys.join('][')}]不是已确认状态，不能发送邮件`,
          type: 'warning',
        })
        return
      }
      this.sendEmail({ checkList: this.checkList })
    },

    sendEmail(param) {
      this.$confirm(
        this.$l('tips_send') || '是否发送邮件？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loading = true
        this.$api
          .ecomOrderSendEmailApi(param)
          .then(() => {
            this.loading = false
            this.$message({
              showClose: true,
              message: this.$l('tips_send_ok') || '发送成功！',
              type: 'success',
            })
            this.reload()
            this.clearCheckList()
          })
          .catch(() => {
            this.loading = false
            this.$message.error(this.$l('tips_send_fail') || '发送失败！')
          })
      })
    },
    batchConfirm() {
      if (!this.checkList || this.checkList.length == 0) {
        this.$message({
          showClose: true,
          message:
            this.$l('please_select_the_confirm_data') ||
            '请选择需要订单确认的数据',
          type: 'warning',
        })
        return
      }
      // 获取已关联请款单的结算单编号
      const errorKeys = this.checkedRow
        .filter((item) => item.orderStatus != 10)
        .map((item) => item.orderNo)

      if (errorKeys && errorKeys.length) {
        this.$message({
          message: `订单[${errorKeys.join('][')}]不是新建状态，不能订单确认`,
          type: 'warning',
        })
        return
      }
      this.confirm({ checkList: this.checkList })
    },

    confirm(param) {
      this.$confirm(
        this.$l('tips_order_confirm') || '是否订单确认？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loading = true
        this.$api
          .ecomOrderConfirmApi(param)
          .then(() => {
            this.loading = false
            this.$message({
              showClose: true,
              message: this.$l('tips_confirm_ok') || '订单确认成功！',
              type: 'success',
            })
            this.reload()
            this.clearCheckList()
          })
          .catch(() => {
            this.loading = false
            this.$message.error(
              this.$l('tips_confirm_fail') || '订单确认失败！'
            )
          })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
